import React from 'react';
import Icon from '../../../components/AppIcon';

const TripLimitationNotice = ({ hasExistingTrip }) => {
  if (!hasExistingTrip) return null;

  return (
    <div className="flex items-start gap-4 p-4 md:p-6 rounded-lg border-2" style={{ 
      backgroundColor: 'var(--color-muted)', 
      borderColor: 'var(--color-border)' 
    }}>
      <div className="flex-shrink-0">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'var(--color-primary)' }}>
          <Icon name="Info" size={24} color="var(--color-primary-foreground)" />
        </div>
      </div>
      <div className="flex-1">
        <h3 className="text-base md:text-lg font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>
          Single Active Trip Limitation
        </h3>
        <p className="text-sm md:text-base mb-3" style={{ color: 'var(--color-text-secondary)' }}>
          You currently have an active trip: <span className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>Caribbean Coastal Cruise</span>
        </p>
        <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
          Creating a new trip will replace your existing configuration. To modify your current trip, use the Trip Settings option in the user menu.
        </p>
      </div>
    </div>
  );
};

export default TripLimitationNotice;